import styles from './styles.module.scss';
import { RevampedHeader } from '../components';
import { TransactionActionButtons } from './components/TransactionActionButtons';
import { TransactionContent } from './components/TransactionContent';
import { PageWrapper } from '../PageWrapper';
import { useEffect, useState } from 'react';
import { SearchFieldWithDebounce, SmartFormIcons } from 'components';
import {
  resetTransactionsSearchEffect,
  searchTransactionsEffect,
  setProjectsFilterEffect,
  setTransactionFiltersAppliedEffect,
  setTransactionsFilterEffect,
  setTransactionsFiltersEffect,
} from 'store/effects';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { getTransactionsSelector } from 'store/selectors/transactions';
import useIsProjectRoute from 'hooks/use-is-project-route';
import { PageSearchWrapper } from '../components/PageSearchWrapper';
import { getIsAdminOrOwnerSelector } from 'store/selectors/agentTeamDetail';
import { getDefaultProjectTeamFilterValue } from './components/TransactionActionButtons/ProjectTeamFilter/helper';

export const Transactions = () => {
  const [isSearchActive, setSearchActive] = useState(false);
  const dispatch = useDispatch();

  const { transactionFilter, isFiltersApplied } = useSelector(getTransactionsSelector);
  const isProject = useIsProjectRoute();

  useEffect(() => {
    transactionFilter && dispatch(setTransactionsFilterEffect(undefined));

    if (isProject) {
      const defaultTeamValue = getDefaultProjectTeamFilterValue()?.itemValue;

      dispatch(setProjectsFilterEffect(defaultTeamValue));
      dispatch(setTransactionFiltersAppliedEffect(false));
    }

    return () => {
      dispatch(setTransactionsFiltersEffect({}));
    };
  }, []);

  return (
    <PageWrapper
      isContainer={false}
      isHideFooter={true}
      pageWrapperContainerClassName={styles.mainPageContent}
    >
      <RevampedHeader
        className={classNames(styles.workshopPageHeader, {
          [styles.activeSearchWorkshopHeader]: isSearchActive,
        })}
        title={isProject ? 'Projects' : 'Transactions'}
        titleClassName={styles.headerTitle}
        actionButtons={<TransactionActionButtons onSearchClick={() => setSearchActive(true)} />}
      />

      <PageSearchWrapper
        isSearchActive={isSearchActive}
        resetAction={resetTransactionsSearchEffect}
        sendAction={searchTransactionsEffect}
        onCloseSearch={() => setSearchActive(false)}
      />

      <TransactionContent
        className={classNames(styles.transactionContent, {
          [styles.activeSearchContent]: isSearchActive,
          [styles.workshopTableContent]: isSearchActive || isFiltersApplied,
        })}
        isSearchActive={isSearchActive}
      />
    </PageWrapper>
  );
};
